module.exports = __webpack_public_path__ + "static/img/3.2c6d036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/3.png
// module id = cRJG
// module chunks = 1